import React, { createContext, useContext, ReactNode } from 'react';
import { useAuth } from '../hooks/useAuth';
import type { User } from '@byte-store-control/shared';

interface AuthContextValue {
  isLoading: boolean;
  isAuthenticated: boolean;
  user?: User;
  logout: () => void;
  refreshToken: () => void;
  accessToken: string;
  environment: string;
  isInMApp: boolean; // True when running inside native MApp container
}

const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export function AuthProvider({ children }: { children: ReactNode }) {
  const { isLoading, user, logout, updatePermissions, accessToken, environment, isInMApp } =
    useAuth();

  const value: AuthContextValue = {
    isLoading,
    isAuthenticated: !!user,
    user,
    logout,
    refreshToken: updatePermissions,
    accessToken,
    environment,
    isInMApp,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuthContext() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }
  return context;
}
